export class InspirationMenu {

  ctx: CanvasRenderingContext2D;

  init(ctx: CanvasRenderingContext2D) {
    this.ctx = ctx;
  }

  draw() {
    this.ctx.globalAlpha = .5;
    this.ctx.fillStyle = "#000";
    this.ctx.fillRect(this.ctx.canvas.width - 200, 0, 200, this.ctx.canvas.height);
  }
}
